import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../app/i18n";
import { RegisterForm } from "../../shared/auth/RegisterForm";
import { guard } from "../../shared/auth/guards";
import { validateRegisterSearch } from "../../shared/auth/search";

export const Route = createFileRoute("/app/register")({
  validateSearch: validateRegisterSearch,
  beforeLoad: async (args) => {
    await Promise.all([guard("guestSeller", args), loadNamespaces("auth")]);
  },
  component: SellerRegister,
});

function SellerRegister() {
  const { redirect, ref } = Route.useSearch();
  return <RegisterForm redirect={redirect} refParam={ref} />;
}
